module.exports = __webpack_public_path__ + "img/vignettes-asso_0001_association-syndrome-de-barth.7c7600c4.jpg";